import {
    deleteThisEventForwardTitleText,
    deleteThisGroupEventForwardSubText,
    deleteThisEventForwardSubText,
    deleteGroupEventSeriesConfirmationSubText,
    deleteGroupEventConfirmationSubText,
} from './deleteCalendarEventWithConfirm.locstring.json';
import { delete_0 } from 'owa-locstrings/lib/strings/delete_0.locstring.json';
import { deleteEventConfirmationSubText } from 'owa-locstrings/lib/strings/deleteeventconfirmationsubtext.locstring.json';
import { deleteEventSeriesConfirmationSubText } from 'owa-locstrings/lib/strings/deleteeventseriesconfirmationsubtext.locstring.json';
import { deleteEventConfirmationTitleText } from 'owa-locstrings/lib/strings/deleteeventconfirmationtitletext.locstring.json';
import { deleteSeriesConfirmationTitleText } from 'owa-locstrings/lib/strings/deleteseriesconfirmationtitletext.locstring.json';
import loc from 'owa-localize';
import EventScope from 'owa-service/lib/contract/EventScope';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { deleteCalendarEvent } from 'owa-calendar-events-actions';
import { userInteractionAction, ViewType } from 'owa-calendar-actions';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Open the delete modal
 */
export default async function deleteCalendarEventWithConfirm(
    item: CalendarEvent,
    eventScope: EventScope,
    isItemSeriesMaster: boolean,
    actionSource: ViewType,
    isInPopOutWindow: boolean,
    onCancel?: () => void,
    onConfirm?: () => void
) {
    let title;
    let text;

    const isGroupCalendarEvent = item.ItemId.mailboxInfo.type === 'GroupMailbox';

    // log event interacted action as user has attempted to delete but not yet deleted
    userInteractionAction('EventDeleteInitiated', actionSource, item.IsOrganizer, item.IsMeeting);

    if (isFeatureEnabled('cal-removeDeleteConfirmationDialog') && !isInPopOutWindow) {
        deleteCalendarEvent(item, actionSource, eventScope, onConfirm);
    } else {
        if (eventScope == EventScope.ThisAndFollowingInstances) {
            title = loc(deleteThisEventForwardTitleText);
            text = isGroupCalendarEvent
                ? loc(deleteThisGroupEventForwardSubText)
                : loc(deleteThisEventForwardSubText);
        } else if (eventScope == EventScope.AllInstancesInSeries || isItemSeriesMaster) {
            // If item is series master, it means for the whole series
            title = loc(deleteSeriesConfirmationTitleText);
            text = isGroupCalendarEvent
                ? loc(deleteGroupEventSeriesConfirmationSubText)
                : loc(deleteEventSeriesConfirmationSubText);
        } else {
            title = loc(deleteEventConfirmationTitleText);
            text = isGroupCalendarEvent
                ? loc(deleteGroupEventConfirmationSubText)
                : loc(deleteEventConfirmationSubText);
        }

        const response = await confirm(title, text, false, {
            okText: loc(delete_0),
            delayCallbackAfterAnimation: true,
        });

        if (response === DialogResponse.ok) {
            userInteractionAction(
                'EventDeleteConfirmed',
                actionSource,
                item.IsOrganizer,
                item.IsMeeting
            );
            deleteCalendarEvent(item, actionSource, eventScope, onConfirm);
        } else {
            userInteractionAction(
                'EventDeleteCancelled',
                actionSource,
                item.IsOrganizer,
                item.IsMeeting
            );
            if (onCancel) {
                onCancel();
            }
        }
    }
}
